import { ModelBase } from "./ModelBase"

export class SupportoModel extends ModelBase {
    Telefono: string;
    OrariUfficio: Array<string>;
    LinkManuale: string;
    LinkStart:string
    LinkCondizioni: string;
}
